import { GAME_TYPES } from '../constants/gameTypes';
import { formatPoints } from './scores';

export const ruleText = (game, playerCount, multiplier = 1) => {
  const points = formatPoints((game.points ?? 0) * multiplier);
  switch (game.id) {
    case GAME_TYPES.DIAMONDS:
      return `${points} per diamond`;
    case GAME_TYPES.QUEENS:
      return `${points} per queen`;
    case GAME_TYPES.LEVATE:
    case GAME_TYPES.WHIST:
      return `${points} per hand`;
    case GAME_TYPES.TEN_OF_CLUBS:
      return `${points} for taking it`;
    case GAME_TYPES.KING_OF_HEARTS:
      return `${points} for taking it`;
    case GAME_TYPES.RENTZ:
      return `Finishing order, up to ${formatPoints(Math.max(playerCount - 1, 0) * game.points * multiplier)}`;
    case GAME_TYPES.TOTALS:
      return 'Every penalty at once';
  }
};
